import { required } from 'vuelidate/lib/validators'
import { messages } from '@/lib/validation-helpers'
import { validationMessage } from 'vuelidate-messages'

export default {
  validations: {
    formData: {
      file: { required },
      valid_from: { required }
    }
  },

  methods: {
    $v_displayMessage: validationMessage(messages)
  }
}
